<nb-actions>
    <nb-action *ngFor="let contentElement of gridCell.contentElements" kwSelectableFeatureHelper [contentElement]="contentElement">{{contentElement?.text}}</nb-action>
    <!-- <div *ngFor="let contentElement of gridCell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
        <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
    </div> -->
</nb-actions>
